export default __webpack_public_path__ + "static/media/ofilsystems_v2.6c67830c.jpg";